import React from "react";
import "./policy.css";

const PrivacyPolicy = () => {
	return (
		<div className="policy-container">
			<h1>Privacy Policy</h1>
			<p className="last-updated">Last Updated: March 2026</p>
			
			<section>
				<h2>1. Introduction</h2>
				<p>
					At our homestay platform, we value your privacy. This policy explains
					how we collect, use, and protect your personal information when you
					browse properties, make bookings, or contact hosts.
				</p>
			</section>
			
			<section>
				<h2>2. Information We Collect</h2>
				<ul>
					<li>Guest details (name, email, phone number)</li>
					<li>Booking information (dates, preferences, number of guests)</li>
					<li>Payment-related details (processed securely via third-party providers)</li>
					<li>Device and browsing data</li>
				</ul>
			</section>
			
			<section>
				<h2>3. How We Use Your Information</h2>
				<ul>
					<li>To confirm and manage your homestay bookings</li>
					<li>To communicate with you and the property host</li>
					<li>To improve our services and user experience</li>
					<li>To send booking updates and important notifications</li>
				</ul>
			</section>
			
			<section>
				<h2>4. Sharing of Information</h2>
				<p>
					We only share necessary information with property owners/hosts to
					complete your booking. We do not sell your personal data.
				</p>
			</section>
			
			<section>
				<h2>5. Cookies</h2>
				<p>
					Cookies help us remember your preferences and improve your browsing
					experience. You can disable cookies in your browser settings.
				</p>
			</section>
			
			<section>
				<h2>6. Data Security</h2>
				<p>
					We use secure technologies to protect your personal data from
					unauthorized access or misuse.
				</p>
			</section>
			
			<section>
				<h2>7. Your Rights</h2>
				<p>
					You can request access, update, or deletion of your personal data by
					contacting us.
				</p>
			</section>
			
			<section>
				<h2>8. Contact Us</h2>
				<p>Email: support@yourhomestay.com</p>
			</section>
		</div>
	);
};

export default PrivacyPolicy;